export var MAX_UNITS_LENGTH = {
  KBYTE: 1024,
  MEGABYTE: Math.pow(1024, 2),
  GIGABYTE: Math.pow(1024, 3),
  TERABYTE: Math.pow(1024, 4),
  SECONDS: 60
};
export var GIFT_VIEW_COOKIE = 'giftViewCookie';